export default __webpack_public_path__ + "static/media/RIPLEY.3392432c.svg";